export const ENVIRONMENTS = {
    LOCAL: "LOCAL",
    DEV: "DEV",
    UAT: "UAT",
    PRODUCTION: "PRODUCTION"
}